import React from 'react'
import DashboardHomepage from '../components/DashboardHomepage'

const Dashboard = () => {
  return (
	<div>
		<DashboardHomepage/>
	</div>
  )
}

export default Dashboard